import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import api from "../../../api/axios";
import { UserRole } from "../../../Types/UserRole/UserRoleModel";


interface UserRoleState {
  roles: UserRole[];
  loading: boolean;
  error: string | null;
}

export const fetchUserRoles = createAsyncThunk(
  "userRoles/fetchUserRoles",
  async (empNo: string, thunkAPI) => {
    try {
      const response = await api.get(`/api/users/${empNo}/roles`);
      return response.data.data as UserRole[];
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Failed to fetch user roles"
      );
    }
  }
);

const storedRoles = localStorage.getItem("user_roles");
const initialRoles: UserRole[] = storedRoles ? JSON.parse(storedRoles) : [];

const initialState: UserRoleState = {
  roles: initialRoles,
  loading: false,
  error: null,
};

const userRoleSlice = createSlice({
  name: "userRoles",
  initialState,
  reducers: {
    clearUserRoles(state) {
        state.roles = [];
        state.loading = false;
        state.error = null;
        localStorage.removeItem("user_roles"); 
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserRoles.fulfilled, (state, action: PayloadAction<UserRole[]>) => {
        state.loading = false;
        state.roles = action.payload; 
        state.error = null;
        localStorage.setItem("user_roles", JSON.stringify(action.payload)); 
      })
      .addCase(fetchUserRoles.rejected, (state, action) => {
        state.loading = false;
        state.roles = [];
        state.error = action.payload as string;
        localStorage.removeItem("user_roles");
      });
  },
});

export const { clearUserRoles } = userRoleSlice.actions;
export default userRoleSlice.reducer;